import Vue from 'vue'

Vue.component('soft-search', require('./SoftSearch.vue').default);

const app = new Vue({
    el: '#electricGuide',
    data: {}
});